jQuery(document).ready(function() {

    // Bootstrap - Tooltips

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {

        return new bootstrap.Tooltip(tooltipTriggerEl);
        
    });
   

    //jQuery('[data-toggle="tooltip"]').tooltip(); // * Deprecated 2022-01-08 

});
